import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { ProofBar } from './components/ProofBar';
import { Testimonials } from './components/Testimonials';
import { Credibility } from './components/Credibility';
import { PainGrid } from './components/PainGrid';
import { BigIdea } from './components/BigIdea';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { Bonuses } from './components/Bonuses';
import { WhyNow } from './components/WhyNow';
import { Pricing } from './components/Pricing';
import { Transformation } from './components/Transformation';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { testimonialsSerie1, testimonialsSerie2 } from './data/testimonials';
export function App() {
  return <div className="min-h-screen w-full bg-creme font-sans text-graphite selection:bg-graphite selection:text-creme" data-id="element-0" data-mp="3ikqwvtvkeu33">
      <MetaPixel data-id="element-1" data-mp="3mk83iqmq9x9u" />
      <main data-id="element-2" data-mp="3mjpyb4i388ps">
        <Hero data-id="element-3" data-mp="3mj6hxs835sdv" />
        <ProofBar data-id="element-4" data-mp="3rcj6618urx63" />
        <Testimonials id="temoignages-1" testimonials={testimonialsSerie1} eyebrow="Témoignages" title="Ce que disent les coachs qui utilisent le système" note="Exemples de mise en page. À remplacer par des témoignages réels, avec photo et consentement écrit, avant publication." tone="paper" data-id="element-5" data-mp="3rbzmog3k10py" />
        <Credibility data-id="element-6" data-mp="33oi1x4ipj2wh" />
        <PainGrid data-id="element-7" data-mp="38m1iwc6shts4" />
        <BigIdea data-id="element-8" data-mp="38kqcs5pvg9xu" />
        <ProductReveal data-id="element-9" data-mp="38k6tolohjfi8" />
        <Tomes data-id="element-10" data-mp="38nupjrheke04" />
        <Bonuses data-id="element-11" data-mp="3dkuws5pznmst" />
        <WhyNow data-id="element-12" data-mp="3dle3eqa6uorj" />
        <Pricing data-id="element-13" data-mp="3dlw5w4ng1z7w" />
        <Transformation data-id="element-14" data-mp="3dmfqjt4hb1pm" />
        <Testimonials id="temoignages-2" testimonials={testimonialsSerie2} eyebrow="Témoignages" title="Des parcours menés jusqu’au bout" note="Exemples de mise en page. Les citations réelles nommeront les composants du système, sans être réécrites par nous." tone="paper" data-id="element-15" data-mp="3dii3iwes5q0g" />
        <Guarantee data-id="element-16" data-mp="3udkmfuysas9v" />
        <Faq data-id="element-17" data-mp="3ubztuaw15jen" />
        <CostOfInaction data-id="element-18" data-mp="3ucjcxuxf2du9" />
        <Close data-id="element-19" data-mp="3uf5lnxw1mze2" />
      </main>
      <Footer data-id="element-20" data-mp="d57d4waue6fw" />
    </div>;
}